// /pages/carrossier/FormulaireB/components/SectionClient.js
import React from "react";
import InputField from "./shared/InputField";

const SectionClient = ({ formData, handleChange, errors }) => {
  return (
    <section className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200">
      <h3 className="text-lg font-semibold mb-6 text-green-600 flex items-center gap-2">
        <span className="text-xl">🏢</span>
        2. Identification client final ou livré
      </h3>
      <div className="grid md:grid-cols-3 gap-6">
        <InputField
          section="client"
          field="Nom"
          placeholder="Nom / Raison sociale *"
          type="text"
          required={true}
          formData={formData}
          handleChange={handleChange}
          errors={errors}
        />
        <InputField
          section="client"
          field="Adresse"
          placeholder="Adresse de livraison"
          type="text"
          formData={formData}
          handleChange={handleChange}
          errors={errors}
        />
        <InputField
          section="client"
          field="Contact"
          placeholder="Contact client"
          type="text"
          formData={formData}
          handleChange={handleChange}
          errors={errors}
        />
      </div>
    </section>
  );
};

export default SectionClient;